<template>
  <div class="document">
    <DocumentPage :dokumentId="$route.params.id"></DocumentPage>
  </div>
</template>

<script>
import DocumentPage from '@/components/DocumentPage.vue'

export default {
  name: 'Grid',
  components: {
      DocumentPage
  }
}</script>